export const getAddressComponent = (address, component) => {
  return address.address_components.find((c) => c.types.indexOf(component) > -1)
    ?.long_name
}
